import { FC, PropsWithChildren, useState } from "react";
import { CombinedInputProps } from "./Input";
import { SleekInput } from "./SleekInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPencil, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button } from "../Button";
import { Form } from "../Form";
import { Severity } from "../../Helpers";
import { useValidator } from "../../Hooks";
import styles from "./InputInline.module.scss";

interface InputInlineProps {
    onSave: (value: string) => void;
    onChange?: never;
    validator?: never;
}

export const InputInline: FC<PropsWithChildren<CombinedInputProps & InputInlineProps>> = (props) => {
    const { onSave, value, onChange, validator, children, ...rest } = props;
    const internalValidator = useValidator();

    const [edit, setEdit] = useState<boolean>(false);
    const [newValue, setNewValue] = useState<string>(value?.toString() ?? "");

    const handleSaveClicked = () => {
        if (newValue === value?.toString()) {
            setEdit(false);
            return;
        }

        if (!internalValidator.canSubmit()) return false;

        onSave(newValue);
        setEdit(false);
    };

    const handleCancelClicked = () => {
        setNewValue(value?.toString() ?? "");
        setEdit(false);
    };

    return (
        <>
            {!edit && (
                <>
                    {props.children} <FontAwesomeIcon icon={faPencil} onClick={() => setEdit(true)} className={styles.edit} />
                </>
            )}

            {edit && (
                <Form>
                    <div className={styles.editing}>
                        <SleekInput
                            validator={internalValidator}
                            value={newValue}
                            onChange={e => setNewValue(e.target.value)}
                            autoFocus={true}
                            {...rest}
                        />
                        <Button
                            onClick={handleSaveClicked}
                            severity={Severity.Success}
                            icon={faCheck}
                            type="submit"
                        />
                        <Button
                            onClick={handleCancelClicked}
                            severity={Severity.Danger}
                            icon={faTimes}
                        />
                    </div>
                </Form>
            )}
        </>
    );
};